(function () {
  'use strict';

  angular
      .module('tfc.Products')
      .factory('StyleSummary', StyleSummaryClass);


  function StyleSummaryClass() {

    function StyleSummary(data){
      if (!(this instanceof StyleSummary)) return new StyleSummary(data);
      this.highReceived = data.highReceived;
      this.highMissing = data.highMissing;
      this.high = this.highMissing + this.highReceived;
      this.lowReceived = data.lowReceived;
      this.lowMissing = data.lowMissing;
      this.low = this.lowReceived + this.lowMissing;
    }

    return StyleSummary;
  }

})();
